var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 51 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.027 25.001c0-10.12-8.214-18.333-18.334-18.333S7.36 14.88 7.36 25c0 8.873 6.306 16.262 14.667 17.967V30.5H18.36v-5.5h3.666v-4.583A6.424 6.424 0 0 1 28.444 14h4.583v5.5H29.36a1.84 1.84 0 0 0-1.834 1.833v3.667h5.5v5.5h-5.5v12.742c9.259-.917 16.5-8.727 16.5-18.242"
  })));
};
export default SvgFacebook;